<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1">
        <v-card
          elevation="0"
          style="
            border-bottom: 2px solid rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            position: sticky;
            top: 60px;
            background: white;
            z-index: 5;
          "
        >
          <v-card-title>
            <p
              class="text-h6 font-weight-bold text-center text-uppercase"
              style="margin: auto"
            >
              Detail Template
              <v-tooltip bottom color="grey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    @click="getDataFromApi"
                    style="position: relative; top: -3px"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>refresh page</span>
              </v-tooltip>
            </p>
          </v-card-title>
          <div class="actionButton">
            <v-btn
              type="button"
              rounded
              elevation="0"
              color="red"
              class="white--text font-weight-bold ma-2"
              style="font-size: 12px"
              @click.prevent="closeformTemplate"
              outlined
            >
              <v-icon small>mdi-chevron-left</v-icon>
              Kembali
            </v-btn>
          </div>
        </v-card>
        <v-card elevation="0" v-if="detailData != null">
          <v-card-text>
            <v-form
              ref="entryForm"
              :disabled="!isEdit"
              @submit.prevent="saveForm"
            >
              <v-container>
                <v-row>
                  <v-col cols="12" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Nama Template
                    </p>
                    <v-text-field
                      v-model="detailData.name"
                      :rules="rules.nameRules"
                      dense
                      outlined
                      style="height: 45px"
                    />
                  </v-col>
                  <v-col cols="12" :md="8" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Perusahaan
                    </p>
                    <v-autocomplete
                      v-model="detailData.company_id"
                      :items="dropdown.company"
                      :rules="rules.companyRules"
                      item-text="name"
                      item-value="id"
                      return-object
                      dense
                      outlined
                      clearable
                      style="height: 45px"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" :md="4" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Tipe Audit
                    </p>
                    <v-autocomplete
                      v-model="detailData.audit_type_id"
                      :items="dropdown.auditType"
                      :rules="rules.typeRules"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
                <v-btn
                  v-if="!isEdit"
                  style="
                    position: absolute;
                    top: -10px;
                    right: 10px;
                    font-weight: bold;
                    padding-left: 2px;
                  "
                  small
                  text
                  outlined
                  color="primary"
                  @click="enableEdit"
                >
                  <v-icon
                    small
                    color="primary"
                    style="position: relative; top: 1px"
                  >
                    mdi-pencil
                  </v-icon>
                  Edit Header
                </v-btn>

                <div v-else style="position: absolute; top: -10px; right: 10px">
                  <v-btn
                    style="font-weight: bold"
                    small
                    text
                    outlined
                    color="primary"
                    type="submit"
                  >
                    <v-icon
                      small
                      color="primary"
                      style="position: relative; top: 1px"
                    >
                      mdi-content-save-edit-outline
                    </v-icon>
                    Save
                  </v-btn>
                  <v-btn
                    style="font-weight: bold; margin-left: 10px"
                    small
                    text
                    outlined
                    color="red"
                    @click="enableEdit"
                  >
                    <v-icon
                      small
                      color="red"
                      style="position: relative; top: 1px"
                    >
                      mdi-cancel
                    </v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-card-actions>
              <v-divider></v-divider>
            </v-form>
          </v-card-text>
          <!-- v-if="
                detailData.form_template_item != null &&
                detailData.form_template_item.lenght > 0
              "
             -->
          <v-card-text>
            <div class="position-relative z-0">
              <v-btn
                v-if="!isEdit"
                color="blue darken-1"
                type="button"
                small
                class="white--text"
                style="position: relative; top: -10px; left: 10px"
                @click="addClause"
              >
                + Add Item
              </v-btn>
              <v-btn
                v-if="!isEdit"
                color="blue darken-1"
                type="button"
                small
                class="white--text"
                style="position: relative; top: -10px; left: 20px"
                @click="generateBatch"
              >
                Generate Batch
              </v-btn>
              <div
                v-if="detailData.audit_type_id == 2"
                style="
                  width: 210px;
                  height: 45px;
                  position: absolute;
                  top: -20px;
                  right: 0;
                  z-index: 2;
                "
              >
                <v-autocomplete
                  v-model="paramAPI.area"
                  :items="dropdown.area"
                  @change="areaWatcher"
                  label="Area"
                  item-text="name"
                  item-value="id"
                  return-id
                  dense
                  outlined
                  clearable
                ></v-autocomplete>
              </div>
              <div
                v-if="detailData.audit_type_id == 1"
                style="
                  width: 210px;
                  height: 45px;
                  position: absolute;
                  top: -20px;
                  right: 0;
                  z-index: 2;
                "
              >
                <v-autocomplete
                  v-model="paramAPI.scope"
                  :items="dropdown.scope"
                  @change="scopeWatcher"
                  label="Scope"
                  item-text="name"
                  item-value="id"
                  return-id
                  dense
                  outlined
                  clearable
                ></v-autocomplete>
              </div>
            </div>
            <v-card v-if="!loading">
              <div v-if="clauseDetail != null">
                <v-tabs
                  v-model="locationTab"
                  background-color="#ccdbdc"
                  slider-color="primary"
                  color="primary"
                  class="mt-5"
                  vertical
                >
                  <v-tab
                    v-for="itemLocation in locationTabItems"
                    :key="itemLocation.tab"
                  >
                    <p
                      class="m-0"
                      style="
                        width: 230px;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                      "
                    >
                      {{ itemLocation.tab }}
                    </p>
                    <v-icon
                      @click.stop="deleteArea(itemLocation)"
                      small
                      color="error"
                    >
                      mdi-delete-circle
                    </v-icon>
                  </v-tab>
                  <v-tabs-items v-model="locationTab">
                    <v-tab-item
                      v-for="itemLocation in locationTabItems"
                      :key="itemLocation.tab"
                      style="padding: 0 5px 5px 5px"
                    >
                      <div style="min-height: 60vh">
                        <v-card dense elevation="0">
                          <v-expansion-panels
                            v-model="panel"
                            focusable
                            multiple
                          >
                            <v-expansion-panel
                              v-for="(obj, i) in clauseDetail[itemLocation.tab]"
                              :key="i"
                            >
                              <v-expansion-panel-header>
                                {{ i }}
                                <div class="d-flex justify-content-end mr-3">
                                  <v-icon
                                    small
                                    color="error"
                                    @click.stop="deleteCategory(obj)"
                                  >
                                    mdi-delete-circle
                                  </v-icon>
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-data-table
                                  fixed-header
                                  mobile-breakpoint="0"
                                  height="50vh"
                                  item-key="id"
                                  style="cursor: pointer"
                                  elevation="1"
                                  :headers="clauseHeaders"
                                  :items="obj"
                                  :loading="loading"
                                  @click:row="clauseRowClick"
                                  :footer-props="{
                                    showFirstLastPage: true,
                                    showCurrentPage: true,
                                    itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                                  }"
                                >
                                  <template v-slot:[`item.no`]="{ index }">
                                    <div
                                      style="
                                        font-size: 14px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                      "
                                    >
                                      {{
                                        index +
                                        1 +
                                        paramAPI.offset * paramAPI.limit
                                      }}
                                    </div>
                                  </template>
                                  <template
                                    v-slot:[`item.clause_desc`]="{ item }"
                                  >
                                    <div
                                      style="
                                        width: 210px;
                                        font-size: 14px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                        color: green;
                                      "
                                    >
                                      {{ item.clause_desc }}
                                    </div>
                                  </template>
                                  <template
                                    v-slot:[`item.clause_no`]="{ item }"
                                  >
                                    <div
                                      style="
                                        width: 120px;
                                        font-size: 14px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                      "
                                    >
                                      {{ item.clause_no }}
                                    </div>
                                  </template>
                                  <template
                                    v-slot:[`item.clause_category_name`]="{
                                      item
                                    }"
                                  >
                                    <div
                                      style="
                                        width: 160px;
                                        font-size: 14px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                      "
                                    >
                                      {{ item.clause_category_name }}
                                    </div>
                                  </template>
                                  <template
                                    v-slot:[`item.clause_ref`]="{ item }"
                                  >
                                    <div
                                      style="
                                        width: 120px;
                                        font-size: 14px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                      "
                                    >
                                      {{ item.clause_ref }}
                                    </div>
                                  </template>
                                  <template v-slot:[`item.area`]="{ item }">
                                    <div
                                      style="
                                        width: 120px;
                                        font-size: 12px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                      "
                                    >
                                      {{
                                        item.area != null
                                          ? item.area.name
                                          : null
                                      }}
                                    </div>
                                  </template>
                                  <template v-slot:[`item.scope`]="{ item }">
                                    <div
                                      style="
                                        width: 120px;
                                        font-size: 12px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;
                                      "
                                    >
                                      {{
                                        item.scope != null
                                          ? item.scope.name
                                          : null
                                      }}
                                    </div>
                                  </template>

                                  <template v-slot:[`item.action`]="{ item }">
                                    <v-tooltip left>
                                      <template v-slot:activator="{ on, attrs }"
                                        ><v-icon
                                          v-bind="attrs"
                                          v-on="on"
                                          @click.stop="clauseRowClick(item)"
                                          small
                                          color="primary"
                                          class="mr-2"
                                        >
                                          mdi-pencil-circle
                                        </v-icon>
                                      </template>
                                      <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip right>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-icon
                                          v-bind="attrs"
                                          v-on="on"
                                          small
                                          color="error"
                                          @click.stop="clauseDeleteItem(item)"
                                        >
                                          mdi-delete-circle
                                        </v-icon>
                                      </template>
                                      <span>Delete</span>
                                    </v-tooltip>
                                  </template>
                                </v-data-table>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels></v-card
                        >
                      </div></v-tab-item
                    >
                  </v-tabs-items>
                </v-tabs>
              </div>
            </v-card>
            <div
              v-else
              class="d-flex justify-center align-center"
              style="height: 150px"
            >
              <v-progress-circular
                :size="80"
                :width="5"
                color="blue"
                indeterminate
                >Loading...</v-progress-circular
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      YOU CANNOT ACCESS THIS PAGE
    </v-card>
    <!-- DIALOG -->

    <v-dialog v-model="formClauseDialog" persistent max-width="800px">
      <v-card v-if="form != null">
        <v-card-title>
          <span class="text-h5">Add/Edit Klausul</span>
        </v-card-title>
        <v-form ref="entryForm2" @submit.prevent="saveClause">
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" md="8" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                  <v-text-field
                    :value="detailData.company_name"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column pl-5">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tipe Audit
                  </p>
                  <v-text-field
                    :value="detailData.audit_type.name"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Klausul
                  </p>
                  <v-autocomplete
                    v-if="form.act == 'add'"
                    v-model="form.clause"
                    clearable
                    deletable-chips
                    small-chips
                    outlined
                    item-text="description"
                    item-id="id"
                    return-object
                    label="Cari klausul"
                    :items="clauseList"
                    :search-input.sync="search"
                    :rules="rules.clauseRules"
                    @change="clauseWatcher"
                  ></v-autocomplete>
                  <v-textarea
                    v-if="form.act == 'update'"
                    :value="form.clause.description"
                    dense
                    outlined
                    auto-grow
                    rows="2"
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="form.clause != null"
                  cols="12"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kategori Klausul
                  </p>
                  <v-text-field
                    dense
                    outlined
                    style="height: 60px"
                    :value="
                      form.clause.clause_category != null
                        ? form.clause.clause_category.name
                        : null
                    "
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="form.clause != null"
                  cols="12"
                  md="4"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No Klausul
                  </p>
                  <v-text-field
                    :value="form.clause.clause_no"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="form.clause != null"
                  cols="12"
                  md="8"
                  class="d-flex flex-column pl-5"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Referensi
                  </p>
                  <v-text-field
                    v-model="form.clause.reference"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="detailData.audit_type_id == 2"
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Area
                  </p>
                  <v-autocomplete
                    v-model="form.area_id"
                    :items="dropdown.area"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-if="detailData.audit_type_id == 1"
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Scope
                  </p>
                  <v-autocomplete
                    v-model="form.scope_id"
                    :items="dropdown.scope"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    small-chips
                    deletable-chips
                    multiple
                    cache-items
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeClauseDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import buildType from '../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'formTemplateDetail',
  data: () => ({
    config: require('../../../services/config.json')[env],
    build: process.env.VUE_APP_BUILD_TYPE,
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    editDialog: false,
    formClauseDialog: false,
    permission: null,
    appLevel: null,
    userLevel: null,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      audit_type_id: null,
      area: null,
      scope: null
      // department_id: null
    },
    detailData: null,
    form: null,
    isEdit: false,
    loading: false,
    isDisableCompanyDropdown: false,
    skeleton_loading: true,
    isLoadingPage: true,
    clauseList: null,
    search: null,
    select: null,
    options: {},
    // result: [],
    clauseDetail: [],
    rules: {
      nameRules: [],
      companyRules: [],
      auditTypeRules: [],
      clauseRules: []
    },
    dropdown: {
      company: [],
      auditType: [],
      department: [],
      area: [],
      scope: []
    },
    panel: [],

    locationTab: null,
    locationTabItems: [],
    detailItem: null
  }),

  async mounted() {
    // this.paramAPI.company_id = Number(
    //   this.getUserProfile.employee.company.plant_id
    // )
    // this.paramAPI.department_id = this.getUserProfile.employee.department_id

    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.getDataMenu()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    // , 'getDropdownPlant', 'getShiftSettingPageQuery'
    ...mapGetters(['getUserProfile']),
    clauseHeaders() {
      const arrClauseHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kategori',
          value: 'clause_category_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Klausul',
          value: 'clause_desc',
          align: 'left',
          sortable: false
        },
        {
          text: 'No Klausul',
          value: 'clause_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ref',
          value: 'clause_ref',
          align: 'left',
          sortable: false
        }
      ]
      // if (this.detailData.audit_type_id == 2) {
      //   arrClauseHeaders.push({
      //     text: 'Area',
      //     value: 'area',
      //     align: 'left',
      //     sortable: false
      //   });
      // }
      // if (this.detailData.audit_type_id == 1) {
      //   arrClauseHeaders.push({
      //     text: 'Scope',
      //     value: 'scope',
      //     align: 'left',
      //     sortable: false
      //   });
      // }
      arrClauseHeaders.push({
        text: 'Actions',
        value: 'action',
        align: 'left',
        sortable: false
      })

      return arrClauseHeaders
    }
  },
  watch: {
    search(val) {
      if (val !== '') {
        val && val !== this.select && this.querySelections(val)
      } else {
        this.select = null
        this.items = []
      }
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations([
      // /*'setOvertimePageQuery'*/
    ]),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    areaWatcher() {
      this.getDataFromApi()
    },
    scopeWatcher() {
      this.getDataFromApi()
    },
    clauseWatcher(xV) {
      console.log(xV)
    },
    async initDropdown() {
      this.getDropdownCompany()
      this.dropdownAuditType()
      this.dropdownArea()
      this.dropdownScope()
      // this.dropdownDepartment()
    },
    async getDropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    async dropdownAuditType() {
      await axios
        .get(`${this.dssApi}master/universal/audittype/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.auditType = res.data.data)
          }
          return (this.dropdown.auditType = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.auditType = [])
        })
    },

    async dropdownArea() {
      await axios
        .get(`${this.dssApi}master/universal/area/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.area = res.data.data)
          }
          return (this.dropdown.area = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.area = [])
        })
    },

    async dropdownScope() {
      await axios
        .get(`${this.dssApi}master/universal/scope/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.scope = res.data.data)
          }
          return (this.dropdown.scope = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.scope = [])
        })
    },

    querySelections(v) {
      console.log(v, v.length)
      let url = `${this.dssApi}master/universal/clause/dropdown?keyword=${v}&join_table=[{"name":"clausecategory","alias":"clause_category"}]`
      const filter = []
      if (this.detailData.company_id !== null) {
        filter.push(`{"company_ids": ${this.detailData.company_id}}`)
      }
      if (this.detailData.audit_type_id !== null) {
        filter.push(`{"audit_type_id": ${this.detailData.audit_type_id}}`)
      }
      if (this.form.area_id) {
        filter.push(`{"area_ids": ${this.form.area_id}}`)
      }
      if (this.form.scope_id) {
        filter.push(`{"scope_ids": ${this.form.scope_id}}`)
      }
      url = url + `&filter=[${filter}]`
      axios
        .get(url)
        .then((res) => {
          console.log(res)
          if (res.data.status_code === '00') {
            return (this.clauseList = res.data.data)
          }
          return (this.clauseList = [])
        })
        .catch((err) => {
          this.clauseList = []
          return console.log(err)
        })
    },

    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      await this.getMenuId({
        keyword: this.paramAPI.keyword,
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            // console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    async initDataForLayout() {
      if (this.userLevel.is_support) {
        this.paramAPI.company_id = {
          id: 0,
          name: ''
        }
      } else {
        this.paramAPI.company_id = {
          id: Number(this.getUserProfile.employee.company.plant_id),
          name: this.getUserProfile.employee.company.name
        }
      }

      // if (
      //   this.getUserProfile.level.find(
      //     ({ id }) => id == this.appLevel.adminMaster
      //   ) !== undefined
      // ) {
      //   this.paramAPI.mode = ''
      // }
      // this.paramAPI.department_id = this.getUserProfile.employee.department_id

      // if (this.getOvertimePageQuery !== null) {
      //   this.paramAPI = this.getOvertimePageQuery
      // }
      setTimeout(async () => {
        this.initDropdown()
        await this.getDataFromApi()
      }, 200)
    },
    async getDataFromApi() {
      this.loading = true
      this.panel = []
      this.clauseDetail = []
      this.locationTab = null
      this.locationTabItems = []
      // this.detailItem = null;
      const url = `${this.dssApi}formtemplate/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            this.detailData = res.data.data
            const formTemplatItem = this.detailData.form_template_item
            const newArrItem = []

            if (formTemplatItem.length > 0) {
              for (let i = 0; i < formTemplatItem.length; i++) {
                var objItem = {
                  id: formTemplatItem[i].id,
                  clause_id:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.id
                      : null,
                  clause_desc:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.description
                      : null,
                  clause_no:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.clause_no
                      : null,
                  clause_ref:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.reference
                      : null,
                  clause_category_id:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.clause_category != null
                        ? formTemplatItem[i].clause.clause_category.id
                        : null
                      : null,
                  clause_category_name:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.clause_category != null
                        ? formTemplatItem[i].clause.clause_category.name
                        : null
                      : null,
                  area: formTemplatItem[i].area,
                  scope: formTemplatItem[i].scope,
                  createdAt:
                    formTemplatItem[i].clause != null
                      ? formTemplatItem[i].clause.createdAt
                      : null
                }
                newArrItem.push(objItem)
              }
            }
            // console.log(newArrItem)
            // this.clauseDetail = newArrItem
            this.groupedByClauseCategoryV2(newArrItem)
          } else {
            this.loading = false
            // this.showMsgDialog('error', res.data.status_msg, false)
          }
          return null
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          return null
        })
    },
    async groupedByClauseCategory(arrItem) {
      let xItemList = arrItem
      if (this.detailData.audit_type_id == 1) {
        if (this.paramAPI.scope != null) {
          xItemList = await xItemList.filter(
            (item) => item.scope.id == this.paramAPI.scope
          )
        }
      }
      if (this.detailData.audit_type_id == 2) {
        if (this.paramAPI.area != null) {
          xItemList = await xItemList.filter(
            (item) => item.area.id == this.paramAPI.area
          )
        }
      }

      const grouping = await xItemList.reduce((acc, item) => {
        // Use empty string if clause_category_name is null
        const categoryName = item.clause_category_name || '-'
        // Initialize the category array if it doesn't exist
        if (!acc[categoryName]) {
          acc[categoryName] = []
        }
        // Add the current item to the appropriate category array
        acc[categoryName].push(item)
        return acc
      }, {})
      // console.log('grouping>>>', Object.keys(grouping).length)
      for (let i = 0; i < Object.keys(grouping).length; i++) {
        this.panel.push(i)
      }

      this.clauseDetail = grouping
      this.loading = false
    },

    async groupedByClauseCategoryV2(arrItem) {
      let xItemList = arrItem
      if (this.detailData.audit_type_id == 1) {
        if (this.paramAPI.scope != null) {
          xItemList = await xItemList.filter(
            (item) => item.scope.id == this.paramAPI.scope
          )
        }
      }
      if (this.detailData.audit_type_id == 2) {
        if (this.paramAPI.area != null) {
          xItemList = await xItemList.filter(
            (item) => item.area.id == this.paramAPI.area
          )
        }
      }
      // console.log('xItemList>>>>', xItemList)
      if (xItemList.length > 0) {
        const grouped = await xItemList.reduce((acc, item) => {
          // console.log('acc>>>>', acc)
          let locationName = '-'
          // let locationId = null

          if (this.detailData.audit_type_id == 1) {
            locationName = item.scope?.name || '-'
            // locationId = item.scope?.id || null
          }
          if (this.detailData.audit_type_id == 2) {
            locationName = item.area?.name || '-'
            // locationId = item.area?.id || null
          }

          // console.log('locationName>>>>', locationName)
          const categoryName = item.clause_category_name || '-'
          // console.log('categoryName>>>>', item.clause_category_name)

          // Initialize area if it doesn't exist
          // console.log('acc[locationName]>>>>', acc[locationName])
          if (!acc[locationName]) {
            acc[locationName] = {}
          }

          // Initialize category inside area if it doesn't exist
          // console.log(
          //   'acc[locationName][categoryName]>>>>',
          //   acc[locationName][categoryName]
          // )
          if (!acc[locationName][categoryName]) {
            acc[locationName][categoryName] = []
          }

          // Push item into the correct category under the correct area
          acc[locationName][categoryName].push(item)

          return acc
        }, {})

        Object.keys(grouped).forEach((areaName) => {
          const categories = grouped[areaName]
          // Object.keys(categories).forEach((categoryName) => {
          //   categories[categoryName].sort((a, b) =>
          //     a.clause_desc != null
          //       ? a.clause_desc.localeCompare(b.clause_desc)
          //       : null
          //   )
          // })
          Object.keys(categories).forEach((categoryName) => {
            categories[categoryName].sort((a, b) => {
              const dateA = new Date(a.createdAt || 0)
              const dateB = new Date(b.createdAt || 0)
              return dateA - dateB // ascending: terlama ke terbaru
            })
          })
        })

        // console.log('grouped>>>', grouped)
        // console.log(grouped['Area Security']['Ringkas']) // eslint-disable-line dot-notation
        // get audit item tab object
        // console.log('groupedSort>>>', Object.keys(grouped).sort())
        for (let i = 0; i < Object.keys(grouped).sort().length; i++) {
          this.locationTabItems.push({
            tab: Object.keys(grouped).sort()[i],
            content: ''
          })
        }
        // console.log('1>>>>>>', Object.keys(grouped[Object.keys(grouped)[0]]))
        // all expension panell on active state
        for (
          let j = 0;
          j < Object.keys(grouped[Object.keys(grouped)[0]]).length;
          j++
        ) {
          this.panel.push(j)
        }
        // console.log('grouped>>>', grouped)
        setTimeout(() => {
          this.clauseDetail = grouped
          this.loading = false
          // console.log('clauseDetail>>>', this.clauseDetail)
        }, 100)
      } else {
        this.clauseDetail = null
        this.loading = false
      }
    },
    enableEdit() {
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.getDataFromApi()
      }
    },

    saveForm() {
      this.rules.nameRules = [(v) => !!v || 'Name is required']
      this.rules.companyRules = [(v) => !!v || 'Company is required']
      this.rules.auditTypeRules = [(v) => !!v || 'Audit Type is required']

      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          const form = {
            act: 'update',
            id: self.detailData.id,
            name: self.detailData.name,
            company_id: self.detailData.company_id,
            company_name: self.detailData.company_name,
            audit_type_id: self.detailData.audit_type_id
          }

          if (self.detailData.department != null) {
            Object.assign(form, {
              department_id: self.detailData.department_id,
              department_name: self.detailData.department_name
            })
          }

          self.submitForm(form)
        }
      })
    },
    async submitForm(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}master/universal/formtemplate/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.enableEdit()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeformTemplate() {
      this.detailData = null
      this.clauseDetail = []
      this.isEdit = false
      setTimeout(() => {
        this.$router.push('/dss/audit/ms/formtemplate')
      }, 300)
    },
    addClause() {
      console.log('add clause')

      this.form = {
        act: 'add',
        formtemplate_id: this.detailData.id,
        clause: null,
        area_id: null,
        scope_id: null
      }
      setTimeout(() => {
        this.formClauseDialog = !this.formClauseDialog
      }, 300)
    },
    clauseRowClick(pItem) {
      console.log('edit clause', pItem)

      this.form = {
        act: 'update',
        id: pItem.id,
        clause: {
          id: pItem.clause_id,
          description: pItem.clause_desc,
          clause_no: pItem.clause_no,
          reference: pItem.clause_ref,
          clause_category: {
            id: pItem.clause_category_id,
            name: pItem.clause_category_name
          }
        },
        area_id: null,
        scope_id: null
      }
      setTimeout(() => {
        this.formClauseDialog = !this.formClauseDialog
      }, 300)
    },
    saveClause() {
      console.log('here')

      this.rules.clauseRules = [(v) => !!v || 'Klausul is required']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm2.validate()) {
          const form = {
            act: self.form.act,
            clause_id: self.form.clause.id
          }

          if (self.form.act == 'add') {
            Object.assign(form, {
              formtemplate_id: self.form.formtemplate_id
            })
          }

          if (self.form.act == 'update') {
            Object.assign(form, {
              id: self.form.id
            })
          }

          if (self.detailData.audit_type_id == 1) {
            Object.assign(form, {
              scope_id: self.form.scope_id
            })
          }

          if (self.detailData.audit_type_id == 2) {
            Object.assign(form, {
              area_id: self.form.area_id
            })
          }

          self.submitClause(form)
        }
      })
    },
    async submitClause(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}formtemplate/item/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            // this.enableEdit()
            this.closeClauseDialog()
            this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeClauseDialog() {
      this.formClauseDialog = !this.formClauseDialog
      setTimeout(() => {
        this.form = null
      }, 300)
    },
    clauseDeleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(`${this.dssApi}formtemplate/item/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    generateBatch() {
      this.showMsgDialog(
        'warning',
        'Data sebelumnya akan hilang. Anda yakin ingin generate semua klausul sekarang ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          const form = {
            act: 'generate',
            id: this.detailData.id
          }

          await axios
            .post(`${this.dssApi}formtemplate/item/generate`, form)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    deleteArea(item) {
      let arrOfArea = []
      if (this.detailData.audit_type_id == 1) {
        arrOfArea = this.detailData.form_template_item.filter(
          ({ scope }) => scope.name == item.tab
        )
      }
      if (this.detailData.audit_type_id == 2) {
        arrOfArea = this.detailData.form_template_item.filter(
          ({ area }) => area.name == item.tab
        )
      }
      // console.log(arrOfArea)
      this.showMsgDialog(
        'question',
        `Anda yakin ingin menghapus ${arrOfArea.length} item ?`,
        true
      ).then(async (res) => {
        const arrSuccess = []
        const arrFail = []
        let i = 0
        if (res.isConfirmed) {
          this.loading = true
          while (
            (await new Promise((resolve, reject) => {
              axios
                .delete(
                  `${this.dssApi}formtemplate/item/delete/${arrOfArea[i].id}`
                )
                .then((res) => {
                  if (res.data.status_code === '00') {
                    arrSuccess.push({
                      index: i,
                      msg: res.data.status_msg
                    })
                  } else {
                    arrFail.push({
                      index: i,
                      msg: res.data.status_msg
                    })
                  }
                  resolve(i++)
                })
                .catch((err) => {
                  console.log(err)
                  arrFail.push({
                    index: i,
                    msg: 'error'
                  })
                  reject(new Error(i++))
                })
            })) <
            arrOfArea.length - 1
          ) {
            console.log('loading... ' + i)
          }
          this.showMsgDialog(
            'success',
            `${arrSuccess.length} data berhasil terhapus <br/> ${
              arrFail.length
            } data gagal terhapus pada index ${JSON.stringify(arrFail)}`,
            false
          )
          this.getDataFromApi()
          this.loading = false
        }
      })
    },
    deleteCategory(item) {
      // let arrOfArea = []
      // if (this.detailData.audit_type_id == 1) {
      //   arrOfArea = this.detailData.form_template_item.filter(
      //     ({ scope }) => scope.name == item.tab
      //   )
      // }
      // if (this.detailData.audit_type_id == 2) {
      //   arrOfArea = this.detailData.form_template_item.filter(
      //     ({ area }) => area.name == item.tab
      //   )
      // }
      console.log(item)
      this.showMsgDialog(
        'question',
        `Anda yakin ingin menghapus ${item.length} item ?`,
        true
      ).then(async (res) => {
        const arrSuccess = []
        const arrFail = []
        let i = 0
        if (res.isConfirmed) {
          this.loading = true
          while (
            (await new Promise((resolve, reject) => {
              axios
                .delete(`${this.dssApi}formtemplate/item/delete/${item[i].id}`)
                .then((res) => {
                  if (res.data.status_code === '00') {
                    arrSuccess.push({
                      index: i,
                      msg: res.data.status_msg
                    })
                  } else {
                    arrFail.push({
                      index: i,
                      msg: res.data.status_msg
                    })
                  }
                  resolve(i++)
                })
                .catch((err) => {
                  console.log(err)
                  arrFail.push({
                    index: i,
                    msg: 'error'
                  })
                  reject(new Error(i++))
                })
            })) <
            item.length - 1
          ) {
            console.log('loading... ' + i)
          }
          this.showMsgDialog(
            'success',
            `${arrSuccess.length} data berhasil terhapus <br/> ${
              arrFail.length
            } data gagal terhapus pada index ${JSON.stringify(arrFail)}`,
            false
          )
          this.getDataFromApi()
          this.loading = false
        }
      })
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.actionButton {
  position: relative;
  display: flex;
  // width: 400px;
}
#formTemplateList {
  position: relative;
  .form-template-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .form-template-list-toolbar2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #formTemplateList {
    .form-template-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .form-template-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
